module.exports = __webpack_public_path__ + "img/nt108-03-81-1.prt.613a81a6.jpg";